export const DATABASECONNECTION_CREATE_RESET = 'DATABASECONNECTION_CREATE_RESET'
export const DATABASECONNECTION_CREATE_SET_CREATED = 'DATABASECONNECTION_CREATE_SET_CREATED'
export const DATABASECONNECTION_CREATE_SET_ERROR = 'DATABASECONNECTION_CREATE_SET_ERROR'
export const DATABASECONNECTION_CREATE_SET_VIOLATIONS = 'DATABASECONNECTION_CREATE_SET_VIOLATIONS'
export const DATABASECONNECTION_CREATE_TOGGLE_LOADING = 'DATABASECONNECTION_CREATE_TOGGLE_LOADING'
